import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { DriverService } from '../shared/driver.service';
import { NavigationService } from '../../shared/services/navigation.service';
import { LoaderService } from '../../shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { LocalLocationService } from '../../local-loads/shared/local-location.service';
import { LocalLocationContainerLight } from '../../local-loads/shared/local-location-container-light.model';
import {UserSearchCriteria} from "../../shared/user-search-criteria";

@Component({
  selector: 'app-plant-manager-list',
  templateUrl: './plant-manager-list.component.html',
  styleUrls: ['./plant-manager-list.component.scss']
})
export class PlantManagerListComponent implements OnInit {

  plants: LocalLocationContainerLight[] = [];
  filters = new UserSearchCriteria();

  loadPage = (page: number, pageSize: number) => this.userService.searchPlantManagers(this.plants, page, pageSize, this.filters);

  constructor(
    private userService: UserService,
    private driverService: DriverService,
    private locationService: LocalLocationService,
    private navigation: NavigationService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
  ) {
  }

  ngOnInit() {
    this.loader.startLoad(false);

    this.locationService.getAvailablePlants()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe((plants) => {
        this.plants = plants;
      }, e => this.errorHandler.handleHttpError(e, 'user-dashboard.users.plant-managers.errors.get-all'));
  }

  goToCreatePlantManager(): void {
    this.navigation.plantManagers()
      .create()
      .go();
  }

  goToEditPlantManager(id: string): void {
    this.navigation.plantManagers()
      .edit(id)
      .go();
  }

}
